import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Calendar, Ticket, ExternalLink } from 'lucide-react';
import { Button } from './ui/Button';
interface Props {
  isOpen: boolean;
  onClose: () => void;
}
interface TicketType {
  name: string;
  earlyPrice: string;
  regularPrice: string;
  registrationUrl: string;
}
const TICKET_TYPES: TicketType[] = [{
  name: 'אדם בחדר זוגי + כרטיס',
  earlyPrice: '1,190',
  regularPrice: '1,322',
  registrationUrl: 'https://www.enerchi.co.il/category/%D7%98%D7%95%D7%A4%D7%A1-%D7%94%D7%A8%D7%A9%D7%9E%D7%94-%D7%9C%D7%90%D7%93%D7%9D-%D7%91%D7%97%D7%93%D7%A8'
}, {
  name: 'אדם בחדר טריפל + כרטיס',
  earlyPrice: '1,190',
  regularPrice: '1,322',
  registrationUrl: '' // תמלאי מאוחר יותר
}, {
  name: 'לילה של חמישי בחדר זוגי + כרטיס',
  earlyPrice: '834',
  regularPrice: '927',
  registrationUrl: '' // תמלאי מאוחר יותר
}, {
  name: 'לילה של שישי בחדר זוגי + כרטיס',
  earlyPrice: '891',
  regularPrice: '990',
  registrationUrl: '' // תמלאי מאוחר יותר
}, {
  name: 'חדר זוגי לבד + כרטיס',
  earlyPrice: '940',
  regularPrice: '1,034',
  registrationUrl: '' // תמלאי מאוחר יותר
}, {
  name: 'לילה של חמישי לחדר זוגי לבד + כרטיס',
  earlyPrice: '850',
  regularPrice: '935',
  registrationUrl: '' // תמלאי מאוחר יותר
}, {
  name: 'לילה של שישי לחדר זוגי לבד + כרטיס',
  earlyPrice: '890',
  regularPrice: '979',
  registrationUrl: '' // תמלאי מאוחר יותר
}, {
  name: 'כרטיס לפסטיבל בלבד',
  earlyPrice: '410',
  regularPrice: '455',
  registrationUrl: 'https://www.enerchi.co.il/category/%D7%94%D7%A8%D7%A9%D7%9E%D7%94-%D7%9C%D7%A4%D7%A1%D7%98%D7%99%D7%91%D7%9C-%D7%97%D7%AA%D7%99%D7%A8%D7%94'
}];
export function WaterTribeFestTicketSelection({
  isOpen,
  onClose
}: Props) {
  const handleTicketClick = (url: string) => {
    if (url) {
      window.open(url, '_blank');
    } else {
      alert('קישור ההרשמה יתווסף בקרוב');
    }
  };
  return <AnimatePresence data-id="element-645">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" data-id="element-646" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-647">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-3xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto pointer-events-auto" onClick={e => e.stopPropagation()} data-id="element-648">
              {/* Header */}
              <div className="sticky top-0 bg-gradient-to-br from-[#0A5F8F] to-[#0D7AB8] text-white p-8 rounded-t-3xl z-10" data-id="element-649">
                <button onClick={onClose} className="absolute top-6 left-6 p-2 hover:bg-white/20 rounded-full transition-colors" data-id="element-650">
                  <X className="w-6 h-6" data-id="element-651" />
                </button>

                <div className="flex items-center gap-3 mb-4" data-id="element-652">
                  <Ticket className="w-8 h-8" data-id="element-653" />
                  <h2 className="text-3xl md:text-4xl font-bold" data-id="element-654">
                    בחירת כרטיס
                  </h2>
                </div>
                <p className="text-blue-100 text-lg" data-id="element-655">
                  12-14 במרץ 2026 | חוף מעגן עדן, כנרת
                </p>

                {/* Pricing Period Info */}
                <div className="mt-6 inline-flex items-center gap-3 bg-white/20 backdrop-blur-md px-6 py-3 rounded-full border border-white/30" data-id="element-656">
                  <Calendar className="w-5 h-5" data-id="element-657" />
                  <div className="text-right text-sm" data-id="element-658">
                    <div className="font-bold" data-id="element-659">הרשמה מוקדמת עד 10.2</div>
                    <div className="text-blue-100" data-id="element-660">הרשמה רגילה מ-11.2</div>
                  </div>
                </div>
              </div>

              {/* Tickets Grid */}
              <div className="p-8 space-y-4" data-id="element-661">
                {TICKET_TYPES.map((ticket, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.05
            }} onClick={() => handleTicketClick(ticket.registrationUrl)} className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6 border-2 border-blue-100 hover:border-[#0A5F8F] hover:shadow-lg transition-all cursor-pointer group" data-id="element-662">
                    <div className="flex items-center justify-between gap-4" data-id="element-663">
                      <div className="flex-1" data-id="element-664">
                        <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-665">
                          {ticket.name}
                        </h3>
                        <div className="flex items-center gap-4 text-sm" data-id="element-666">
                          <div className="flex items-center gap-2" data-id="element-667">
                            <span className="text-gray-600" data-id="element-668">הרשמה מוקדמת:</span>
                            <span className="font-bold text-indigo-600 text-lg" data-id="element-669">
                              ₪{ticket.earlyPrice}
                            </span>
                          </div>
                          <div className="h-4 w-px bg-gray-300" data-id="element-670" />
                          <div className="flex items-center gap-2" data-id="element-671">
                            <span className="text-gray-600" data-id="element-672">הרשמה רגילה:</span>
                            <span className="font-bold text-purple-600 text-lg" data-id="element-673">
                              ₪{ticket.regularPrice}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 text-[#0A5F8F] group-hover:text-cyan-600 transition-colors" data-id="element-674">
                        <span className="font-medium text-sm" data-id="element-675">בחר</span>
                        <ExternalLink className="w-5 h-5" data-id="element-676" />
                      </div>
                    </div>
                  </motion.div>)}
              </div>

              {/* Footer Note */}
              <div className="p-8 pt-0" data-id="element-677">
                <div className="bg-amber-50 border-2 border-amber-200 rounded-2xl p-6 text-center" data-id="element-678">
                  <p className="text-gray-700" data-id="element-679">
                    <span className="font-bold text-amber-600" data-id="element-680">💡 טיפ:</span>{' '}
                    חסכו עד 100 ₪ בהרשמה מוקדמת עד ה-10.2!
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}